import React from "react";
import PropTypes from "prop-types";
import { StackedBarChart, makeWidthFlexible } from "@unifiedpatents/euclid-react";
import { withChartData } from "../common/chart-data-hoc";
import { withChartConfig } from "../common/chart-config-hoc";
import { getEntityApplicationsByDate } from "../../services/api-prosecution";

const Activities = props => {
  const Chart = withChartConfig(withChartData(makeWidthFlexible(StackedBarChart), getEntityApplicationsByDate, { name: props.name, field: props.field }));
  return <Chart height={300} tickLabelAngleX={-30} colorMap={{ "Issued": "rgb(24, 144, 255)", "Abandoned": "rgb(158, 158, 158)" }} />;
};

Activities.propTypes = {
  name: PropTypes.string.isRequired,
  field: PropTypes.string.isRequired
};

export default Activities;
